import React, { useEffect, useState } from 'react';
import { FiArrowUpCircle } from 'react-icons/fi';
import AOS from 'aos';
import 'aos/dist/aos.css';









const BackToTopButton = () => {

    useEffect(() => {
        AOS.init({
            duration: 2000
        })
    }, [])
    
    
    
    
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setIsVisible(scrollTop > 400);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll); 
        };
    }, []);



    const handleBackToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    }

    return (
        <div className='shadow-xl print:hidden'>
            <div className={`animation fixed bottom-5 right-3  ${isVisible ? 'block' : 'hidden'}`}  data-aos='fade-up'>
                <button onClick={handleBackToTop} className='tooltip tooltip-left' data-tip='Back To Top'><FiArrowUpCircle className='text-5xl  text-sky-600  hover:text-amber-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300' ></FiArrowUpCircle></button>
            </div>
        </div>
    );
};

export default BackToTopButton;